import { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { getStoredValue, removeStoredValue, setStoredValue } from "../_helpers/storagehelper";
import { purchaseCreditsActions } from "../_store";

const useTransactionPending = () => {
    const dispatch = useDispatch();

    const initialTransactionPending = {
        name: "",
        emailId: "",
        poTransactionID: "",
        poTransactionRandomID: "",
        stripeResponse: "Transaction Pending",
        processingFee: "",
        amount: 0,
        transactionDate: new Date()
            .toLocaleString("en-US", {
                timeZone: "America/New_York",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
            })
            .replace(",", ""),
    };

    const [isTransactionModified, setIsTransactionModified] = useState(false);

    const [transactionData, setTransactionData] = useState(() => {
        const saved = getStoredValue("transactionPending");
        return saved ? saved : initialTransactionPending;
    });

    const [isSaveTriggered, setIsSaveTriggered] = useState(false);

    // 🔹 Save to local storage
    useEffect(() => {
        if (isTransactionModified) {
            setStoredValue("transactionPending", transactionData);
        }
    }, [transactionData, isTransactionModified]);

    // 🔹 Send to backend
    useEffect(() => {
        if (isSaveTriggered) {
            const savedData = getStoredValue("transactionPending");
            if (savedData) {
                dispatch(purchaseCreditsActions.SendMailForFailedTransaction(savedData))
                    .then(() => {
                        clearTransaction();
                    })
                    .catch(() => {
                        // Optional: retry or logging
                    });
                clearTransaction();
            } else {
                clearTransaction();
            }
        }
    }, [isSaveTriggered, dispatch]);

    // 🔹 Clear transaction
    const clearTransaction = useCallback(() => {
        setIsSaveTriggered(false);
        setTransactionData(initialTransactionPending);
        setIsTransactionModified(false);
        removeStoredValue("transactionPending");
    }, [initialTransactionPending]);

    return {
        transactionData,
        isTransactionModified,
        setIsTransactionModified,
        clearTransaction,
        setIsSaveTriggered,
        isSaveTriggered,
    };
};

export default useTransactionPending;